// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/icons/embedded.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/icons/not-embedded.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_graphTip__xH53r {
    font-weight: 300;
    display: flex;
    align-items: center;
    margin-bottom: 24px;
}

.styles_graphTip__xH53r:before {
    content: '';
    display: block;
    margin-right: 17px;
    width: 12px;
    min-width: 12px;
    height: 12px;
    box-sizing: border-box;
}

.styles_graphTip__xH53r.styles_initial__XoKp1:before {
    background: var(--primary-color);
}

.styles_graphTip__xH53r.styles_nav__RBSH3:before {
    border: 1px solid var(--primary-color);
}

.styles_graphTip__xH53r.styles_taxed__XeCw1:before {
    border: 1px solid var(--secondary-color);
}

.styles_graphTip__xH53r.styles_embedded__p\\+xGq:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.styles_graphTip__xH53r.styles_notEmbedded__4RmyL:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.styles_graphTip__xH53r.styles_embedded__p\\+xGq:before,
.styles_graphTip__xH53r.styles_notEmbedded__4RmyL:before {
    width: 109px;
    min-width: 109px;
    background-position: center right 0;
    background-repeat: no-repeat;
    height: 12px;
}

.styles_graphTip__xH53r.styles_notEmbedded__4RmyL:before {
    background-size: 100% auto;
    height: 30px;
}

.styles_graphTip__xH53r.styles_embedded__p\\+xGq,
.styles_graphTip__xH53r.styles_notEmbedded__4RmyL {
    white-space: nowrap;
}

.styles_info__wlT\\+h {
    display: flex;
    width: calc(100% + 60px);
}

.styles_info__wlT\\+h img {
    margin-left: -90px;
    width: 16px;
}

.styles_info__wlT\\+h h3 {
    white-space: nowrap;
    font-size: 24px;
    font-weight: 400;
    margin-bottom: 20px;
    display: block;
}

.styles_info__wlT\\+h h5 {
    display: flex;
    justify-content: space-between;
    grid-gap: 5px;
    margin-bottom: 4px;
    white-space: nowrap;
    max-width: 230px;
}

.styles_info__wlT\\+h h5 span {
    width: 50px;
}

.styles_info__wlT\\+h h5:last-child {
    border-bottom: 1px solid #707070;
    padding-bottom: 10px;
}

.styles_highlight__c51Go {
    color: var(--secondary-color);
}
`, "",{"version":3,"sources":["webpack://./src/pages/TaxOptimisationTemplate/components/styles.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,yDAAuD;AAC3D;;AAEA;IACI,yDAA2D;AAC/D;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;IAChB,mCAAmC;IACnC,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":[".graphTip {\n    font-weight: 300;\n    display: flex;\n    align-items: center;\n    margin-bottom: 24px;\n}\n\n.graphTip:before {\n    content: '';\n    display: block;\n    margin-right: 17px;\n    width: 12px;\n    min-width: 12px;\n    height: 12px;\n    box-sizing: border-box;\n}\n\n.graphTip.initial:before {\n    background: var(--primary-color);\n}\n\n.graphTip.nav:before {\n    border: 1px solid var(--primary-color);\n}\n\n.graphTip.taxed:before {\n    border: 1px solid var(--secondary-color);\n}\n\n.graphTip.embedded:before {\n    background-image: url('/src/assets/icons/embedded.svg');\n}\n\n.graphTip.notEmbedded:before {\n    background-image: url('/src/assets/icons/not-embedded.svg');\n}\n\n.graphTip.embedded:before,\n.graphTip.notEmbedded:before {\n    width: 109px;\n    min-width: 109px;\n    background-position: center right 0;\n    background-repeat: no-repeat;\n    height: 12px;\n}\n\n.graphTip.notEmbedded:before {\n    background-size: 100% auto;\n    height: 30px;\n}\n\n.graphTip.embedded,\n.graphTip.notEmbedded {\n    white-space: nowrap;\n}\n\n.info {\n    display: flex;\n    width: calc(100% + 60px);\n}\n\n.info img {\n    margin-left: -90px;\n    width: 16px;\n}\n\n.info h3 {\n    white-space: nowrap;\n    font-size: 24px;\n    font-weight: 400;\n    margin-bottom: 20px;\n    display: block;\n}\n\n.info h5 {\n    display: flex;\n    justify-content: space-between;\n    grid-gap: 5px;\n    margin-bottom: 4px;\n    white-space: nowrap;\n    max-width: 230px;\n}\n\n.info h5 span {\n    width: 50px;\n}\n\n.info h5:last-child {\n    border-bottom: 1px solid #707070;\n    padding-bottom: 10px;\n}\n\n.highlight {\n    color: var(--secondary-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"graphTip": `styles_graphTip__xH53r`,
	"initial": `styles_initial__XoKp1`,
	"nav": `styles_nav__RBSH3`,
	"taxed": `styles_taxed__XeCw1`,
	"embedded": `styles_embedded__p+xGq`,
	"notEmbedded": `styles_notEmbedded__4RmyL`,
	"info": `styles_info__wlT+h`,
	"highlight": `styles_highlight__c51Go`
};
export default ___CSS_LOADER_EXPORT___;
